const regeneratorRuntime = require("regenerator-runtime");
const autoComplete = require("./autoComplete.min.js");

$(document).ready(function() {

    if ($(".search-content").length) {
        $.ajax({
            url: Routing.generate("acpm_ajax_search_datas", {'searchText' : $('#search-datas-form input[name="terms"]').val() }),
            method: 'GET',
            dataType: 'json',
            success: function(response) {
                $(".count-datas span").html(response.countResults);
            }
        });
    }

    if ($(".search-datas").length) {
        $.ajax({
            url: Routing.generate("acpm_ajax_search_contents", {'searchText' : $('#search-datas-form input[name="motcle"]').val() }),
            method: 'GET',
            dataType: 'json',
            success: function(response) {
                $(".count-contents span").html(response.countResults);
            }
        });
    }

  const autoCompleteJS = new autoComplete({
    name: "searchDatas",
    placeHolder: "Rechercher une marque, un titre, un site, une actualité",
    selector: "#searchDatas",
    data: {
      src: async (query) => {
        const source = await fetch(Routing.generate("acpm_search_autocomplete", {'alpha': query}));
        return await source.json();
      },
      key: ["member"],
      cache: false,
    },
    threshold: 3,
    resultItem: {
      highlight: true
    },
    events: {
      input: {
        selection: (event) => {
          const selection = event.detail.selection.value;
          autoCompleteJS.input.value = selection;
        }
      }
    },
    resultsList: {
      destination: "#searchDatas",
      maxResults: 6,
    },
    submit: true
  });

  const searchPageACJS = new autoComplete({
    name: "searchDatasPage",
    placeHolder: "Rechercher une marque, un titre, un site, une actualité",
    selector: "#searchDatasPage",
    data: {
      src: async (query) => {
        const source = await fetch(Routing.generate("acpm_search_autocomplete", {'alpha': query}));
        return await source.json();
      },
      key: ["member"],
      cache: false,
    },
    threshold: 3,
    resultItem: {
      highlight: true
    },
    events: {
      input: {
        selection: (event) => {
          const selection = event.detail.selection.value;
          searchPageACJS.input.value = selection;
        }
      }
    },
    resultsList: {
      destination: "#searchDatasPage",
      maxResults: 6,
    },
    submit: true
  });

  const topAutoComplete = new autoComplete({
    name: "topSearch",
    placeHolder: "Que recherchez-vous ?",
    selector: "#topSearch",
    data: {
      src: async (query) => {
        const source = await fetch(Routing.generate("acpm_search_autocomplete", {'alpha': query}));
        return await source.json();
      },
      key: ["member"],
      cache: false,
    },
    threshold: 3,
    resultItem: {
      highlight: true
    },
    events: {
      input: {
        selection: (event) => {
          const selection = event.detail.selection.value;
          topAutoComplete.input.value = selection;
        }
      }
    },
    resultsList: {
      destination: "#topSearch",
      maxResults: 6,
    },
    submit: true
  });

});